import UserActivityInterface from './UserActivityInterface';
import { UserActivityInterfaceType } from './types';

export { createNoopUserActivityInterface } from './NoopInterface';

let userActivityInterface: UserActivityInterface;

export function getUserActivityInterface(): UserActivityInterface {
  return userActivityInterface;
}
export function clearUserActivityInterface(): void {
  userActivityInterface = undefined;
}

export async function initializeUserActivityInterface(): Promise<UserActivityInterfaceType> {
  if (userActivityInterface) return userActivityInterface.getInterface();

  userActivityInterface = new UserActivityInterface();

  return userActivityInterface.getInterface();
}
